import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import About from "./components/About";
import Services from "./components/Services";
import Menu from "./components/Menu";
import Reservation from "./components/Reservation";
import CateringSection from "./components/CateringSection";
import Gallery from "./components/Gallery";
import Testimonials from "./components/Testimonials";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import { Toaster } from "./components/ui/toaster";
import useReveal from "./hooks/useReveal";
import { LanguageProvider } from "./i18n/LanguageContext";
import { BackgroundsProvider } from "./contexts/BackgroundsContext";
import AdminApp from "./admin/AdminApp";

const Home = () => {
  useReveal();
  return (
    <div className="App">
      <Navbar />
      <main>
        <Hero />
        <About />
        <Services />
        <Menu />
        <Reservation />
        <CateringSection />
        <Gallery />
        <Testimonials />
        <Contact />
      </main>
      <Footer />
      <Toaster />
    </div>
  );
};

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LanguageProvider><BackgroundsProvider><Home /></BackgroundsProvider></LanguageProvider>} />
        <Route path="/admin" element={<AdminApp />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;